/*
  Collection cards (assets/vg-kollektion.css), on collection pages and the home page. With a mouse, hover lights a card in CSS alone.
  On touch screens there is no hover, so the cards in the middle band of the screen light up while scrolling.
  A page can hold several grids (the home page has one per tab); the script may load more than once.
*/
(function () {
  function setup() {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.vg-stage-grid:not([data-vg-stage])').forEach(function (grid) {
      grid.setAttribute('data-vg-stage', '');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-lit', entry.isIntersecting);
        });
      }, { rootMargin: '-36% 0px -36% 0px' });
      grid.querySelectorAll('product-item.vg-stage').forEach(function (card) {
        observer.observe(card);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
